import React, { useMemo } from 'react'
import useOfferList from 'hooks/Offers/useOfferList'
import { MAX_CAROUSEL_ITEM_COUNT } from './common/constants'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_HOTEL, OFFER_TYPE_VILLA } from 'constants/offer'
import OfferCarouselLookingForSomethingElse from '../LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import { LOOKING_FOR_SOMETHING_ELSE_CONTENT } from '../LookingForSomethingElse/constants'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import useOfferListFilters from 'hooks/Offers/useOfferListFilters'
import Places from 'constants/places'
import { VILLAS_TOP_LOCATIONS } from 'constants/villas'

const VILLA_OFFER_TYPES: App.OfferListOfferType[] = [OFFER_TYPE_VILLA, OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON]
const DEFAULT_FILTERS = {
  offerTypes: VILLA_OFFER_TYPES,
  holidayTypesScoped: ['Homes & Villas'],
  destinations: [Places.Anywhere.id],
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
}

const ANYWHERE_DESTINATION = {
  label: 'Around the world',
  value: Places.Anywhere.id,
}

function VillaOfferCarousel() {
  const offerListFilters: App.OfferListFilterOptions = useOfferListFilters(DEFAULT_FILTERS)

  const additionalTopLocationFilters = useMemo(() => {
    return [
      ANYWHERE_DESTINATION,
      ...VILLAS_TOP_LOCATIONS.filter(location => {
        const filter = offerListFilters.filters?.locations?.[location.value]
        return !!filter && filter >= 3
      }),
    ]
  }, [offerListFilters.filters?.locations])

  const offerList = useOfferList(DEFAULT_FILTERS)

  const to = useMemo(() => {
    return LOOKING_FOR_SOMETHING_ELSE_CONTENT.villas.to
  }, [])

  if (offerList.offerIds.length === 0 && !offerList.fetching) {
    return null
  }

  return (
    <OfferCardCarouselSection
      filters={DEFAULT_FILTERS}
      additionalFilters="locations"
      additionalFilterOptions={additionalTopLocationFilters}
      defaultFilter={Places.Anywhere.id}
      title={<> Unwind in our <i>homes & villas</i></>}
      allLink={to}
    >
      <OfferCarouselLookingForSomethingElse to={to} />
    </OfferCardCarouselSection>
  )
}

export default React.memo(VillaOfferCarousel)
